"use strict";

exports.__esModule = true;
exports.Toggle = void 0;

var React = _interopRequireWildcard(require("react"));

var _Toggle = require("./Toggle.styles");

var _hooks = require("@manifest-ui/hooks");

var _utils = require("@manifest-ui/utils");

var _jsxFileName = "/home/runner/work/manifest-ui/manifest-ui/packages/toggle/src/Toggle.tsx";

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Toggle = React.forwardRef((props, ref) => {
  const {
    children,
    defaultChecked,
    id: idProp,
    isChecked: isCheckedProp,
    isDisabled,
    isReadOnly,
    isRequired,
    name,
    onBlur,
    onChange,
    onFocus,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseEnter,
    onMouseLeave,
    onMouseUp,
    tabIndex = undefined,
    value,
    ...other
  } = props;
  const id = (0, _hooks.useId)(idProp);
  const [isChecked, setIsChecked] = (0, _hooks.useControlled)({
    defaultValue: defaultChecked ?? false,
    value: isCheckedProp
  });
  const [isFocused, setIsFocused] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);
  const [isActive, setIsActive] = React.useState(false);
  const handleBlur = React.useCallback(() => {
    setIsFocused(false);
  }, [setIsFocused]);
  const handleChange = React.useCallback(event => {
    if (isReadOnly || isDisabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }

    setIsChecked(!isChecked);
    onChange?.(event);
  }, [isChecked, isDisabled, isReadOnly, onChange, setIsChecked]);
  const handleFocus = React.useCallback(() => {
    setIsFocused(true);
  }, [setIsFocused]);
  const handleKeyDown = React.useCallback(event => {
    if (event.key === ' ') {
      setIsActive(true);
    }
  }, [setIsActive]);
  const handleKeyUp = React.useCallback(event => {
    if (event.key === ' ') {
      setIsActive(false);
    }
  }, [setIsActive]);
  const handleMouseDown = React.useCallback(event => {
    event.preventDefault();
    setIsActive(true);
  }, [setIsActive]);
  const handleMouseEnter = React.useCallback(() => {
    setIsHovered(true);
  }, [setIsHovered]);
  const handleMouseLeave = React.useCallback(() => {
    setIsHovered(false);
  }, [setIsHovered]);
  const handleMouseUp = React.useCallback(() => {
    setIsActive(false);
  }, [setIsActive]);
  return React.createElement(_Toggle.StyledToggleLabel, {
    className: "manifestui-toggle-label",
    "data-checked": isChecked ? '' : undefined,
    "data-disabled": isDisabled ? '' : undefined,
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 140,
      columnNumber: 5
    }
  }, React.createElement(_Toggle.StyledToggleInput, {
    "aria-disabled": isDisabled,
    "aria-checked": isChecked,
    checked: isChecked,
    className: "manifestui-toggle-input",
    disabled: isDisabled,
    id: id,
    name: name,
    onBlur: (0, _utils.chainCallbacks)(onBlur, handleBlur),
    onFocus: (0, _utils.chainCallbacks)(onFocus, handleFocus),
    onChange: handleChange,
    onKeyDown: (0, _utils.chainCallbacks)(onKeyDown, handleKeyDown),
    onKeyUp: (0, _utils.chainCallbacks)(onKeyUp, handleKeyUp),
    ref: ref,
    readOnly: isReadOnly,
    required: isRequired,
    value: value,
    tabIndex: tabIndex,
    type: "checkbox",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 7
    }
  }), React.createElement(_Toggle.StyledToggleContainer, _extends({
    "aria-hidden": "true",
    className: "manifestui-toggle-container",
    "data-active": isActive ? '' : null,
    "data-checked": isChecked ? '' : null,
    "data-disabled": isDisabled ? '' : null,
    "data-focus": isFocused ? '' : null,
    "data-hover": isHovered ? '' : null,
    "data-readonly": isReadOnly ? '' : null,
    onMouseDown: (0, _utils.chainCallbacks)(onMouseDown, handleMouseDown),
    onMouseEnter: (0, _utils.chainCallbacks)(onMouseEnter, handleMouseEnter),
    onMouseLeave: (0, _utils.chainCallbacks)(onMouseLeave, handleMouseLeave),
    onMouseUp: (0, _utils.chainCallbacks)(onMouseUp, handleMouseUp)
  }, other, {
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 165,
      columnNumber: 7
    }
  })), children && React.createElement(_Toggle.StyledToggleText, {
    className: "manifestui-toggle-text",
    __self: void 0,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 181,
      columnNumber: 9
    }
  }, children));
});
exports.Toggle = Toggle;
Toggle.displayName = 'Toggle';